/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Langswitcher_LabelInputs */

const en_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const ar_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللغة`)
};

const bn_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভাষা`)
};

const de_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

const es_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const fr_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langue`)
};

const pt_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idioma`)
};

const zh_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const tr_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dil`)
};

const ru_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Язык`)
};

const pl_langswitcher_label = /** @type {(inputs: Langswitcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Język`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Langswitcher_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const langswitcher_label = /** @type {((inputs?: Langswitcher_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Langswitcher_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_langswitcher_label(inputs)
	if (locale === "bn") return bn_langswitcher_label(inputs)
	if (locale === "de") return de_langswitcher_label(inputs)
	if (locale === "es") return es_langswitcher_label(inputs)
	if (locale === "fr") return fr_langswitcher_label(inputs)
	if (locale === "pt") return pt_langswitcher_label(inputs)
	if (locale === "zh") return zh_langswitcher_label(inputs)
	if (locale === "tr") return tr_langswitcher_label(inputs)
	if (locale === "ru") return ru_langswitcher_label(inputs)
	if (locale === "pl") return pl_langswitcher_label(inputs)
	return en_langswitcher_label(inputs)
});